import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import { DataIngestionCreateDto, DataIngestionListDto, DataIngestionFileRequest, FileValidationResult } from '../dtos/data-ingestion.types';
import { dehumanize } from "@alduino/humanizer/string";

@Injectable({
    providedIn: 'root'
})
export class DataIngestionService extends HttpBaseService {
    private readonly baseEndpoint = 'api/DataIngestions';

    /**
     * Get all data ingestion records
     */
    getAllDataIngestions(): Observable<DataIngestionListDto[]> {
        return this.get<DataIngestionListDto[]>(this.baseEndpoint);
    }

    /**
     * Upload a file for data ingestion
     * @returns Observable containing the created ingestion's ID
     */
    uploadFile(fileRequest: DataIngestionFileRequest): Observable<{ id: string }> {
        const formData = new FormData();
        formData.append('file', fileRequest.file);
        formData.append('name', fileRequest.name || '');
        formData.append('objectDefinitionId', fileRequest.objectDefinitionId);

        return this.post<{ id: string }>(this.baseEndpoint, formData);
    }


    /**
     * Create a data ingestion record with optional file upload
     * @returns Observable containing the created ingestion's ID
     */
    createDataIngestion(ingestion: DataIngestionCreateDto, file?: File): Observable<{ id: string }> {
        const formData = new FormData();

        formData.append('Commentary', ingestion.commentary);
        formData.append('ImportType', ingestion.type.toString());
        formData.append('DefinitionId', ingestion.objectDefinitionId);
        // Add DTO properties to form data
        // Object.keys(ingestion).forEach(key => {
        //     formData.append(dehumanize(key), ingestion[key]?.toString() || '');
        // });

        // Add file if provided
        if (file) {
            formData.append('file', file);
        }

        return this.post<{ id: string }>(this.baseEndpoint, formData);
    }

    /**
     * Validate a data ingestion
     */
    validateDataIngestion(ingestionId: string): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/${ingestionId}/validate`);
    }

    rejectDataIngestion(ingestionId: string, commentary?: string): Observable<void> {
        const body = { commentary };
        return this.patch<void>(`${this.baseEndpoint}/${ingestionId}/reject`, body);
    }

    /**
     * Cancel a data ingestion
     */
    cancelDataIngestion(ingestionId: string): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/${ingestionId}/cancel`);
    }

    /**
     * Validate a file against an object definition's properties
     * @returns Observable containing validation results
     */
    validateFile(file: File, objectDefinitionId: string): Observable<FileValidationResult> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('objectDefinitionId', objectDefinitionId);

        return this.post<FileValidationResult>(`${this.baseEndpoint}/validate-file`, formData);
    }
}